import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsMuteAllDescription = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-mute-all-description", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsMuteAllDescription;
